import { jsx } from "react/jsx-runtime";
import GridOnIcon from "@mui/icons-material/GridOn";
import { validateTidalLicense } from "../../base/index.js";
function GridOn(props) {
  return /* @__PURE__ */ jsx(
    GridOnIcon,
    {
      "data-testid": "GridOn",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "GridOn",
      "data-tidal-icon-meta": "layout"
    }
  );
}
GridOn.tidalIconMeta = {
  categories: "layout",
  name: "GridOn"
};
validateTidalLicense();
export {
  GridOn
};
//# sourceMappingURL=GridOn.js.map
